import React, { createContext, useState, useEffect }  from 'react';
import { withFirebase } from '../Firebase';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import JSZip from 'jszip'
import { saveAs } from 'file-saver';

import SuccessSnackbar from '../Snackbar/SnackbarSuccess';
import FailureSnackbar from '../Snackbar/SnackbarFailure';

import useStyles from '../../styles/styles'

const UserPage = ( {firebase} ) => {

  const [savedImages, setSavedImages] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);
  const [ displayMessage, setDisplayMessage ] = useState('')

  const trimArray = searchHistory.slice(Math.max(searchHistory.length - 10, 1))

  useEffect(
    () => {
      if(firebase.currentUser) {
        var user = firebase.currentUser;
        firebase.getSavedImages(user.uid).then((savedImages) => {
          setSavedImages(savedImages)
        })
      }
    }, [ firebase.currentUser, firebase.db ]
  )

  useEffect(
    () => {
      if(firebase.currentUser) {
        var user = firebase.currentUser;
        firebase.getSearchHistory(user.uid).then((searchHistory) => {
          setSearchHistory(searchHistory)
        })
      }
    }, [ firebase.currentUser, firebase.db ]
  )

  useEffect(
    () => {
      if(displayMessage)
      {
      setTimeout(() => setDisplayMessage(''), 1000)
      }
    }, [ displayMessage ]
  )

  const removeImage = (image) => {
    if(savedImages.includes(image)) {
       const changedImages = savedImages.filter( img => img !== image )
       firebase.saveImages(firebase.currentUser.uid, changedImages).then(
         () => setSavedImages(changedImages)
       )
     }
     setDisplayMessage('deleted')
   }

   const downloadAllImages = (filename, urls) => {
    console.log(urls)
    const zip = new JSZip()
    const folder = zip.folder('my album')
    urls.forEach((url) => {
      const blobPromise = fetch(url).then(r => {
        if (r.status === 200 ) return r.blob()
        return Promise.reject(new Error(r.statusText))
      })

      const name = url.substring(url.lastIndexOf('/'), url.lastIndexOf('?') ) + '.jpg'
      folder.file(name, blobPromise)
    })

    zip.generateAsync({ type: 'blob'})
      .then (blob => saveAs(blob, filename))
      .catch(e => console.log(e))

   }

   
  const classes = useStyles();

  return (
    <div >
        <Container className={classes.cardGrid} maxWidth="md">
              <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                My Album
              </Typography>
              <p>Previous Searches :
              <ol>
                {((searchHistory.length > 0) ? 
                  (trimArray.map(item =>
                    <li>
                      <Link href={`/?q=${item}`}>{item}</Link>
                    </li>
                    )
                  )
                  : 
                  'Loading....')
              }
              </ol>

            <Button onClick={() => downloadAllImages('album-download', savedImages) }size="large" align="center" variant="contained" color="primary">Download All Images</Button>
            </p>
              <Grid container spacing={4}>
                { (savedImages.length > 0 ? savedImages.map(item => (
                  <Grid item key={item} xs={12} sm={6} md={4}>
                    <Card className={classes.card}>
                      <CardMedia
                        className={classes.cardMedia}
                        image={item}
                      />
                      <CardActions>
                        <Button onClick={() => removeImage(item) } size="small" color="primary">
                        Remove
                        </Button>
                        <Button href={item} size="small" color="primary">
                        Download
                        </Button>
                      </CardActions>
                    </Card>
                    {displayMessage === 'deleted' && <FailureSnackbar message={'Deleted'} />}
                  </Grid>
                ))  : console.log('no images'))
              }
              </Grid>
            </Container>
    </div>
  );
}


export default withFirebase(UserPage);
